/**
 * Shared landing-page primitives used across Hero, Portfolio, CabinetOptions,
 * FieldEvidenceVideos, SegmentedPathways and other extracted sections.
 *
 * Keep this file lean — only atoms/helpers that multiple sections need.
 */
import React from "react";
import { ArrowRight, ArrowUpRight } from "lucide-react";

export const Overline = ({ children, icon: Icon }) => (
  <span className="inline-flex items-center gap-2 font-mono text-[11px] font-bold uppercase tracking-[0.22em] text-[#00FF85]">
    {Icon && <Icon size={12} />}
    <span className="text-[#A1A1AA]">{children}</span>
  </span>
);

export const SectionLabel = ({ id, label }) => (
  <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#52525B]">
    /{String(id).padStart(2, "0")} — {label}
  </span>
);

export const openLeadModal = (type = "sales", source = "platform") => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent("bbc:open-lead", { detail: { type, source } }),
  );
};

export const ButtonPrimary = ({ children, href, onClick, testId, lead, source }) => (
  <a
    href={lead ? undefined : (href || "#")}
    role={lead ? "button" : undefined}
    tabIndex={lead ? 0 : undefined}
    onClick={(e) => {
      if (lead) {
        e.preventDefault();
        openLeadModal(lead, source || testId || "platform");
      }
      if (onClick) onClick(e);
    }}
    data-testid={testId}
    className="group cursor-pointer inline-flex items-center gap-3 bg-[#00FF85] hover:bg-[#00CC6A] text-white font-semibold px-7 py-4 text-sm uppercase tracking-wider transition-all shadow-[0_0_24px_rgba(0,255,133,0.35)] hover:shadow-[0_0_36px_rgba(0,255,133,0.6)]"
  >
    {children}
    <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
  </a>
);

export const ButtonGhost = ({ children, href, onClick, testId, lead, source }) => (
  <a
    href={lead ? undefined : (href || "#")}
    role={lead ? "button" : undefined}
    tabIndex={lead ? 0 : undefined}
    onClick={(e) => {
      if (lead) {
        e.preventDefault();
        openLeadModal(lead, source || testId || "platform");
      }
      if (onClick) onClick(e);
    }}
    data-testid={testId}
    className="group cursor-pointer inline-flex items-center gap-3 border border-white/15 hover:border-white text-white font-semibold px-7 py-4 text-sm uppercase tracking-wider hover:bg-white/5 transition-all"
  >
    {children}
    <ArrowUpRight size={14} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
  </a>
);
